import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { BasePageComponent } from '../../base-page.component';
import { PeopleService, LanguageService } from '../../shared/services/index';

@Component({
    templateUrl: './translations.component.html',
    standalone: false
})
export class TranslationsPageComponent extends BasePageComponent implements OnInit {
  public loading = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private peopleService: PeopleService,
    private language: LanguageService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.peopleService.getCurrent().subscribe((data) => {
      this.currentPerson = data;
    });
  }

  exportTranslations() {
    this.language.downloadTranslations();
  }

  uploadTranslations(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    if (files.length > 0) {
      this.loading = true;
      const inputFile = new FormData();
      inputFile.append('files[0]', files[0], files[0].name);
      this.language.uploadTranslations(inputFile).subscribe((data) => {
        this.loading = false;
      });
    }
  }

  uploadTranslationFiles(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    if (files.length > 0) {
      this.loading = true;
      const inputFile = new FormData();
      inputFile.append('files[0]', files[0], files[0].name);
      this.language.uploadTranslationFiles(inputFile).subscribe((data) => {
        this.loading = false;
      });
    }
  }

  goToBack(): void {
    this.router.navigate([this.settingsRoute]);
  }
}
